export const kamernetCitiesRedirect = [
  'eindhoven',
  'enschede',
  'groningen',
  'maastricht',
  'tilburg',
];
